import * as API from '../'
export default {
  //获取下级行政区shape数据
  getSubPosition_simple: params => {
    return API.GET(process.env.BASESERVER+'/farmsituation/listSubPositiontest',params)
  },

  //获取大屏中间的统计数据
  get_big_screen_middle_up_info: params => {
    return API.POST(process.env.big_screen_Server+'/index/stat/detail',params)
  },

  //获取大屏区域作业的业务数据
  get_big_screen_middle_down_info: params => {
    return API.POST(process.env.baseSysURL+'/enterprise/stat/enterprise/map',params)
  },

  //获取服务组织调用接口
  get_server_ori_info: params => {
    return API.POST(process.env.big_screen_Server+'/index/stat/serviceOrg',params)
  },

  //获取合同汇总调用接口
  get_contract_sum_info: params => {
    return API.POST(process.env.big_screen_Server+'/index/stat/contract',params)
  },
  //获取大屏接口-右上-今日作业
  get_today_work_day:params=>{
    return API.POST(process.env.big_screen_Server+'/index/stat/today/work/list',params)
  },
  //获取大屏接口-右中-服务组织统计排名
  get_service_sort:params=>{
    return API.POST(process.env.big_screen_Server+'/index/stat/enterprise/work/list',params)
  },
 //获取大屏接口-右下-近一周作业统计
  get_Statistics_work_week:params=>{
    return API.POST(process.env.big_screen_Server+'/index/stat/week/work/list',params)
  },
   //获取作业汇总调用接口
   get_assignment_sum_info: params => {
    return API.POST(process.env.big_screen_Server+'/index/stat/work',params)
  },
  // 补贴项目列表GET
  getProjectList: param => {
    return API.GET(process.env.baseMachineryServer + '/subsidy/plan/list', param);
  },

  // 示范社统计 大屏
  getGradeList: param => {
    return API.POST(process.env.baseSysURL + '/enterprise/stat/subArea/grade', param);
  },

  policyNews(params){
    return API.POST(process.env.big_screen_temp_server+'/nqjc/article', params)
  },

  // 政策资讯详情
  policyDetail(params){
    return API.GET(process.env.articles_server+'v1/app/article/detail', params)
  },

}



// WEBPACK FOOTER //
// ./src/api/bigScreen/api_big_screen.js